export default {
    USERS: '/users/',
    ENTERPRISES: '/enterprises/list',
    EMAIL_ENTERPRISES_MAP: '/emailEnterpriseMapper/'
}


// WEBPACK FOOTER //
// ./src/urls.js